import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

interface modalParams {
    title?: string,
    confirm?: boolean,
    buttons?: Array<any>,
    ref: NgbModalRef,
    context?: Object
};

@Component({
    selector: 'custom-modal',
    templateUrl: './custom-modal.component.html',
    styleUrls: ['./custom-modal.component.scss']
})
export class CustomModalComponent implements OnInit {

    @Input() params: modalParams = {
        title: '',
        confirm: false,
        buttons: [],
        ref: null,
        context: null
    };

    constructor(public activeModal: NgbActiveModal) { }

    ngOnInit() {
    }

    closeModal(data, dismiss: boolean = false) {
        if (dismiss) this.params.ref.dismiss(data);
        else this.params.ref.close(data);
    }

}
